<template>
  <a-upload name="file"
            :multiple="true"
            :action="uploadAction"
            :headers="headers"
            :data="uploadData"
            :fileList="fileList"
            :beforeUpload="beforeUpload"
            @change="handleChange"
            :disabled="disabled"
            list-type="picture-card">
    <a-button>
      <a-icon type="upload" />{{ text }}
    </a-button>
  </a-upload>
</template>

<script>
const FILE_TYPE_ALL = "all"
const FILE_TYPE_IMG = "image"
const FILE_TYPE_TXT = "file"
import Vue from 'vue'
import { ACCESS_TOKEN } from "@/store/mutation-types"
import { getFileAccessHttpUrl } from '@/api/manage';


const uidGenerator = () => {
  return '-' + parseInt(Math.random() * 10000 + 1, 10);
}
const getFileName = (path) => {
  if (path.lastIndexOf("\\") >= 0) {
    let reg = new RegExp("\\\\", "g");
    path = path.replace(reg, "/");
  }
  return path.substring(path.lastIndexOf("/") + 1);
}
export default {
  name: 'JUpload',
  data () {
    return {
      headers: {},
      fileList: [],
      newFileList: [],
    }
  },
  props: {
    uploadAction: {
      type: [String, Function, Promise],
      default: window._CONFIG['domianURL'] + "/goldenstone.base/goldStoneJpglist/upload",
    },
    text: {
      type: String,
      required: false,
      default: "点击上传"
    },
    fileType: {
      type: String,
      required: false,
      default: FILE_TYPE_ALL
    },
    /*这个属性用于控制文件上传的业务路径*/
    bizPath: {
      type: String,
      required: false,
      default: "jeecg"
    },
    value: {
      type: [String, Array],
      required: false
    },
    // update-begin- --- author:wangshuai ------ date:20190929 ---- for:Jupload组件增加是否能够点击
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    // update-end- --- author:wangshuai ------ date:20190929 ---- for:Jupload组件增加是否能够点击
    //此属性被废弃了
    triggerChange: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * update -- author:lvdandan -- date:20190219 -- for:Jupload组件增加是否返回url，
     * true：仅返回url
     * false：返回fileName filePath fileSize
     */
    uploadData: {
      type: Function,
      required: false,
      default: function () {
        return {}
      }
    },
    beforeUpload: {
      type: Function,
      required: false,
      default: function () {
        return {}
      }
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    maxCount: {
      type: Number,
      default: 1
    }
  },
  watch: {
    value (val) {
      if (val instanceof Array) {
        console.log(val)
        if (this.returnUrl) {
          this.initFileList(val.join(','))
        } else {
          this.initFileListArr(val);
        }
      } else {
        this.fileList = [];
      }
    }
  },
  created () {
    const token = Vue.ls.get(ACCESS_TOKEN);
    this.headers = { "X-Access-Token": token }
  },

  methods: {
    initFileListArr (val) {
      if (!val || val.length == 0) {
        this.fileList = [];
        return;
      }
      let fileList = [];
      for (var a = 0; a < val.length; a++) {
        fileList.push({
          uid: uidGenerator(),
          name: val[a].fileName,
          status: 'done',
          url: val[a].fileUrl,
        })
      }
      this.fileList = fileList
    },
    handleChange (info) {
      console.log("--文件列表改变--")
      console.log(info)
      let fileList = info.fileList
      if (info.file.status === 'done') {
        if (info.file.type.indexOf('image') < 0) {
          this.$message.warning('请上传图片');
          setTimeout(() => {
            this.handleDelete(info.file)
          }, 1000)
          return false
        }
        if (info.file.response.success) {
          fileList = fileList.map((file) => {
            if (file.response) {
              let reUrl = file.response.message;
              file.url = getFileAccessHttpUrl(reUrl, this.urlDownload, "http");
            }
            return file;
          });
        }else {
          this.$message.warn(info.file.response.message);
          setTimeout(() => {
            this.handleDelete(info.file)
          }, 1000)
        }
        //this.$message.success(`${info.file.name} 上传成功!`);
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败.`);
      } else if (info.file.status === 'removed') {
        this.handleDelete(info.file)
      }
      this.fileList = fileList
      if (info.file.status === 'done' || info.file.status === 'removed') {
        //returnUrl为true时仅返回文件路径
        if (this.returnUrl) {
          this.handlePathChange()
        } else {
          //returnUrl为false时返回文件名称、文件路径及文件大小
          this.newFileList = [];
          fileList = fileList.filter((file) => {
            if (file.response) {
              return file.response.success === true;
            }
            return false;
          }).map((file) => {
            console.log('file的值',file);
            if(file.response.code===200) {
              file.response.result.map(item => {
                var fileJson = {
                  fileName: item.newFileName,
                  filePath: item.filePath,
                  fileSize: file.size,
                  fileUrl: item.fileUrl,
                  message: file.response.message,
                };
                this.newFileList.push(fileJson);
              })
            this.$emit('change', this.newFileList);
            this.$message.success('图片上传成功');
            }else{
              this.$message.warn('图片上传失败');
            }
          });
        }
      }
    },
    handleDelete (file) {
      this.fileList = this.fileList.filter(item => item.name != file.name);
      this.$emit('change', this.fileList);
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  }
}
</script>

<style scoped>
</style>